<template>
    <div>
        <vs-button v-can:any="[sheet_obj.permission]" @click.stop="onClickDownload" color="warning" class="mr-2" type="border"
            icon-pack="feather" icon="icon-download">
            {{ button_label }}
        </vs-button>
        <DownloadExcelSheetPopUp ref="downloadExcelSheetPopUp" />
    </div>
</template>
<script>
import DownloadExcelSheetPopUp from '../popups/excel-download/DownloadExcelSheetPopUp.vue';
export default {
    name: 'ExcelDownload',
    data() {
        return {
            sheet_list: [
                {
                    name: 'customer-sheet',
                    title: 'Customer List',
                    filters: [
                        { key: 'account_currency', value: 'account_currency', options: [], type: 'dropdown', label: 'Account Currency', root_key: 'currency' },
                        { key: 'customer_status', value: 'status', options: [], type: 'dropdown', label: 'Customer Status', root_key: 'status' }
                    ],
                    end_point: 'data/customers',
                    permission: 'download-customers-data',
                },
                {
                    name: 'rm-supplier-sheet',
                    title: 'RM Supplier List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'supplier_status', value: 'status', options: [], type: 'dropdown', label: 'Supplier Status', root_key: 'status' },
                    ],
                    end_point: 'data/raw-material-suppliers',
                    permission: 'download-raw-material-suppliers-data',
                },
                {
                    name: 'sundry-supplier-sheet',
                    title: 'Sundry Supplier List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'supplier_status', value: 'status', options: [], type: 'dropdown', label: 'Supplier Status', root_key: 'status' },
                    ],
                    end_point: 'data/sundry-suppliers',
                    permission: 'download-sundry-suppliers-data',
                },
                {
                    name: 'courier-supplier-sheet',
                    title: 'Courier Supplier List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'supplier_status', value: 'status', options: [], type: 'dropdown', label: 'Supplier Status', root_key: 'status' },
                    ],
                    end_point: 'data/courier-suppliers',
                    permission: 'download-courier-suppliers-data',
                },
                {
                    name: 'other-supplier-sheet',
                    title: 'Other Supplier List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'supplier_status', value: 'status', options: [], type: 'dropdown', label: 'Supplier Status', root_key: 'status' },
                    ],
                    end_point: 'data/other-suppliers',
                    permission: 'download-other-suppliers-data',
                },
                {
                    name: 'customer-order-sheet',
                    title: 'Sales Orders',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'date-from', options: [], type: 'date', label: 'Date From', root_key: 'date-from' },
                        { key: '', value: 'date-to', options: [], type: 'date', label: 'Date To', root_key: 'date-to' },
                        { key: '', value: 'due-date-from', options: [], type: 'date', label: 'Due Date From', root_key: 'due-date-from' },
                        { key: '', value: 'due-date-to', options: [], type: 'date', label: 'Due Date To', root_key: 'due-date-to' },
                        // { key: 'customer_id', value: 'customer_id', options: [], type: 'dropdown', label: 'Customer', select_type: 'single' },
                        { key: 'account_currency', value: 'currency', options: [], type: 'dropdown', label: 'Account Currency', root_key: 'currency' },
                        { key: 'item-status', value: 'status', options: [], type: 'dropdown', label: 'Order Item Status', root_key: 'status' },
                        { key: 'item-status', value: 'inverse-status', options: [], type: 'dropdown', label: 'Show Orders Except', root_key: 'inverse-status' },
                        { key: 'customer_account_type', value: 'account-type', options: [], type: 'dropdown', label: 'Customer Account Type', select_type: 'single', root_key: 'account-type' },
                        { key: 'customer_status', value: 'customer_status', options: [], type: 'dropdown', label: 'Customer Status', select_type: 'single', root_key: 'customer_status' },
                        { key: 'account_handler_id', value: 'account-handler-id', options: [], type: 'dropdown', label: 'Account Handler', select_type: 'multiple', root_key: 'account-handler-id' },
                        { key: 'staff', value: 'ordered-by', options: [], type: 'dropdown', label: 'Ordered By', select_type: 'multiple', root_key: 'ordered-by' },
                    ],
                    end_point: 'data/customer-orders',
                    permission: 'download-customer-orders-data',
                },
                {
                    name: 'rm-order-sheet',
                    title: 'Purchase Orders',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', root_key: 'date-from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', root_key: 'date-to' },
                        { key: 'supplier_id', value: 'supplier_id', options: [], type: 'dropdown', label: 'Supplier', select_type: 'single' },
                        { key: 'rm-item-status', value: 'item_status', options: [], type: 'dropdown', label: 'Order Item Status', root_key: 'item-status' },
                        { key: 'rm_order_payment_status', value: 'payment-status', options: [], type: 'dropdown', label: 'Payment Status', root_key: 'payment-status' },
                    ],
                    end_point: 'data/raw-material-orders',
                    permission: 'download-raw-material-orders-data',
                },
                {
                    name: 'work-orders-sheet',
                    title: 'Work Orders',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'status', value: 'status', options: [], type: 'dropdown', label: 'Work Order Status', root_key: 'status' },
                        { key: 'date-from', value: 'date-from', options: [], type: 'date', label: 'Manufacturing From Date', root_key: 'date-from' },
                        { key: 'date-to', value: 'date-to', options: [], type: 'date', label: ' Manufacturing To Date', root_key: 'date-to' },
                        { key: 'shipment-date-from', value: 'shipment-date-from', options: [], type: 'date', label: 'Shipment From Date', root_key: 'shipment-date-from' },
                        { key: 'shipment-date-to', value: 'shipment-date-to', options: [], type: 'date', label: ' Shipment To Date', root_key: 'shipment-date-to' },
                    ],
                    end_point: 'data/work-orders',
                    permission: 'download-work-order-data',
                },
                {
                    name: 'sundry-order-sheet',
                    title: 'Sundry Orders',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', root_key: 'to' },
                        { key: 'sundry-order-item-status', value: 'item-status', options: [], type: 'dropdown', label: 'Order Item Status', root_key: 'item-status' },
                        { key: 'rm_order_payment_status', value: 'payment-status', options: [], type: 'dropdown', label: 'Payment Status', root_key: 'payment-status' },
                    ],
                    end_point: 'data/sundry-orders',
                    permission: 'download-sundry-orders-data',
                },
                {
                    name: 'shipment-sheet',
                    title: 'Shipments',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', root_key: 'to' },
                        { key: 'shipment_status', value: 'status', options: [], type: 'dropdown', label: 'Item Status', root_key: 'status' },
                        { key: 'shipment_types', value: 'is-exw', options: [], type: 'dropdown', label: 'Shipment Type', root_key: 'is_exw', select_type: 'single' },
                    ],
                    end_point: 'data/courier-shipments',
                    permission: 'download-courier-shipments-data',
                },
                {
                    name: 'other-order-sheet',
                    title: 'Other Service Order List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date' , root_key: 'to'},
                        { key: 'rm_order_payment_status', value: 'payment-status', options: [], type: 'dropdown', label: 'Payment Status', root_key: 'payment-status' },
                        { key: 'other-order-status', value: 'status', options: [], type: 'dropdown', label: 'Order Status', root_key: 'status' },
                        { key: 'staff', value: 'staff-ids', options: [], type: 'dropdown', label: 'Orderer Name', root_key: 'ordered-by' },
                    ],
                    end_point: 'data/other-orders',
                    permission: 'download-other-orders-data',
                },
                {
                    name: 'rm-sheet',
                    title: 'Raw Material List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'raw_material_status', value: 'status', options: [], type: 'dropdown', label: 'RM Status', root_key: 'status' },
                    ],
                    end_point: 'data/raw-materials',
                    permission: 'download-raw-materials-data',
                },
                {
                    name: 'credit-note-sheet',
                    title: 'Credit Note List',
                    filters: [
                    { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', root_key: 'to' },
                        { key: 'credit_note_status', value: 'status', options: [], type: 'dropdown', label: 'Credit Note Status', root_key: 'status' },
                    ],
                    end_point: 'data/credit-notes',
                    permission: 'download-credit-notes-data',
                },
                {
                    name: 'rm-waste-sheet',
                    title: 'Raw Material Waste Sheet',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'Created From Date', required: false, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'Created To Date', required: false, root_key: 'to' },
                        { key: '', value: 'disposed-from', options: [], type: 'date', label: 'Disposed From Date', required: false, root_key: 'disposed-from' },
                        { key: '', value: 'disposed-to', options: [], type: 'date', label: 'Disposed To Date', required: false, root_key: 'disposed-to' },
                        { key: 'rm_waste_status', value: 'status', options: [], type: 'dropdown', label: 'Status', root_key: 'status' },
                    ],
                    end_point: 'report/raw-material-waste',
                    permission: 'view-raw-material-waste-inventory',
                },
                {
                    name: 'product-waste-sheet',
                    title: 'Product Waste Sheet',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'Created From Date', required: false, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'Created To Date', required: false, root_key: 'to' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: false, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: false, root_key: 'to' },
                        { key: 'product_waste_status', value: 'status', options: [], type: 'dropdown', label: 'Status', root_key: 'status' },
                    ],
                    end_point: 'report/product-waste',
                    permission: 'view-product-waste-inventory',
                },
                {
                    name: 'sundry-waste-sheet',
                    title: 'Sundry Waste Sheet',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'Created From Date', required: false, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'Created To Date', required: false, root_key: 'to' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: false, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: false, root_key: 'to' },
                        { key: 'sundry_waste_status', value: 'status', options: [], type: 'dropdown', label: 'Status', root_key: 'status' },
                    ],
                    end_point: 'report/sundry-waste',
                    permission: 'view-sundry-waste-inventory',
                },
                // {
                //     name: 'so-invoice-sheet',
                //     title: 'Sales Order Invoices Sheet',
                //     filters: [
                //         { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: true },
                //         { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: true },
                //     ],
                //     end_point: 'data/customer-invoices-v1',
                //     permission: 'view-invoice',
                // },
                {
                    name: 'so-invoice-sheet',
                    title: 'Sales Order Invoices Sheet',
                    filters: [
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: true, root_key: 'from_date' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: true, root_key: 'to_date' },
                        { key: 'invoice-status', value: 'status', options: [], type: 'dropdown', label: 'Invoice Status', root_key: 'status' },
                    ],
                    filters_map: { 'from-date' : 'from', 'to_date': 'to', 'status': 'status' },
                    end_point: 'data/customer-invoices-v2',
                    permission: 'download-customer-invoices-data',
                },
                {
                    name: 'formulation-sheet',
                    title: 'Formulation List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'formulations_status', value: 'status', options: [], type: 'dropdown', label: 'FG Status', root_key: 'status' },
                        { key: 'formulation_applications', value: 'applications', options: [], type: 'dropdown', label: 'Applications', required: false, root_key: 'applications' },
                        { key: 'yes_no', value: 'mf-missing', options: [], type: 'dropdown', label: 'Do you want formulations with default M&F settings?', select_type: 'single', required: false },
                    ],
                    end_point: 'data/formulations',
                    permission: 'download-formulations-data',
                    is_email: true,
                },
                {
                    name: 'sundry-item-sheet',
                    title: 'Sundry Item List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'sundry-item-status', value: 'status', options: [], type: 'dropdown', label: 'Sundry Item Status', root_key: 'status' },
                    ],
                    end_point: 'data/sundry-items',
                    permission: 'download-sundry-items-data',
                },
                {
                    name: 'other-service-sheet',
                    title: 'Other Service List',
                    filters: [],
                    end_point: 'data/other-services',
                    permission: 'download-other-services-data',
                },
                {
                    name: 'sales-quote-sheet',
                    title: 'Sales Quote List',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'sales_quote_status', value: 'status', options: [], type: 'dropdown', label: 'Status', root_key: 'status' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: false, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: false, root_key: 'to' },
                    ],
                    end_point: 'data/sales-quotes',
                    permission: 'download-sales-quotes-data',
                },
                {
                    name: 'sample-orders-sheet',
                    title: 'Sample Orders',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: false, root_key: 'date-from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: false, root_key: 'date-to' },
                        { key: 'sample_order_status', value: 'status', options: [], type: 'dropdown', label: 'Order Status', root_key: 'status' },
                        { key: 'customer_id', value: 'customer-ids', options: [], type: 'dropdown', label: 'Customers' },
                        { key: 'customer_lead_id', value: 'customer-lead-ids', options: [], type: 'dropdown', label: 'Customer Leads',  },
                        { key: 'account_handler_id', value: 'account-handler', options: [], type: 'dropdown', label: 'Account Handler', root_key: 'account-handler' },
                        { key: 'industry_sector', value: 'sector', options: [], type: 'dropdown', label: 'Industry Sectors', root_key: 'sector' },
                        { key: 'customer_source', value: 'source', options: [], type: 'dropdown', label: 'Customer Sources', root_key: 'source' },
                    ],
                    end_point: 'data/sample-orders',
                    permission: 'download-sample-orders-data',
                },
                {
                    name: 'customer-sample-orders-sheet',
                    title: 'Sample Orders by Customer',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: false, root_key: 'date-from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: false, root_key: 'date-to' },
                        { key: 'sample_order_status', value: 'status', options: [], type: 'dropdown', label: 'Order Status', root_key: 'status' },
                        { key: 'customer_id', value: 'customer-ids', options: [], type: 'dropdown', label: 'Customer', select_type: 'single', root_key: 'customer_ids', is_hidden: true },
                        // { key: 'customer_lead_id', value: 'customer-lead-id', options: [], type: 'dropdown', label: 'Customer Lead', select_type: 'single' },
                        // { key: 'account_handler_id', value: 'account-handler', options: [], type: 'dropdown', label: 'Account Handler', root_key: 'account-handler' },
                        // { key: 'industry_sector', value: 'sector', options: [], type: 'dropdown', label: 'Industry Sectors', root_key: 'sector' },
                        // { key: 'customer_source', value: 'source', options: [], type: 'dropdown', label: 'Customer Sources', root_key: 'source' },
                    ],
                    end_point: 'data/sample-orders',
                    permission: 'download-sample-orders-data',
                },
                {
                    name: 'customer-vam-sheet',
                    title: 'Customer VAM',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: false, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: false, root_key: 'to' },
                        { key: 'account_handler_id', value: 'account-handler-id', options: [], type: 'dropdown', label: 'Account Handler', root_key: 'account-handler-id' },
                        { key: 'customer_id', value: 'customer-ids', options: [], type: 'dropdown', label: 'Customers' , root_key:'customer-ids'},
                        { key: 'industry_sector', value: 'sector', options: [], type: 'dropdown', label: 'Industry Sectors', root_key: 'sector'},
                        { key: 'country', value: 'country', options: [], type: 'dropdown', label: 'Country', root_key: 'country'},
                        { key: 'vam_types', value: 'type', options: [], type: 'dropdown', label: 'Type(s)', root_key: 'type'},
                        
                    ],
                    end_point: 'data/customer/crm-vams',
                    permission: 'download-customer-crm-vam-data',
                    check_data_available: true
                },
                {
                    name: 'project-brief-sheet',
                    title: 'Project Brief',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: 'project_brief_status', value: 'status', options: [], type: 'dropdown', label: 'Status', root_key: 'status' },
                        { key: 'account_handler_id', value: 'staff-id', options: [], type: 'dropdown', label: 'Assigned Staff', root_key: 'staff_id' },
                        { key: 'customer_id', value: 'customer-ids', options: [], type: 'dropdown', label: 'Customer', root_key: 'customer_id' },
                        { key: 'industry_sector', value: 'industry-sector', options: [], type: 'dropdown', label: 'Industry Sectors', root_key: 'industry_sector' },
                    ],
                    end_point: 'data/project-briefs',
                    permission: 'download-customers-project-brief-data',
                },
                {
                    name: 'supplier-site-accreditation',
                    title: 'Site Accreditation Document',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', root_key: 'to' },
                    ],
                    end_point: 'report/site-accreditation-report',
                    permission: 'download-raw-material-orders-data',
                },
                {
                    name: 'supplier-invoice-sheet',
                    title: 'PO Invoices Sheet',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: true, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: true, root_key: 'to' },
                        { key: 'po-order-types', value: 'order-type', options: [], type: 'dropdown', label: 'Order Type', root_key: 'order_type' },
                        { key: 'po_invoice_status', value: 'payment-status', options: [], type: 'dropdown', label: 'Payment Status', root_key: 'payment_status' },
                    ],
                    end_point: 'data/supplier-invoices-v2',
                    permission: 'download-supplier-invoices-data',
                },
                {
                    name: 'customer-users-sheet',
                    title: 'Customer Users Sheet',
                    filters: [
                        { key: 'customer_id', value: 'customer_ids', options: [], type: 'dropdown', label: 'Customer', root_key: 'customer_ids' },
                    ],
                    end_point: 'data/customer/users',
                    permission: 'download-customers-data',
                },
                {
                    name: 'customer-all-data-sheet',
                    title: 'Customer Data Sheet',
                    filters: [],
                    end_point: 'data/customer/all-customers',
                    permission: 'download-customers-data',
                },
                {
                    name: 'sundry-slow-stock-report',
                    title: 'Slow Stock Report - Sundry Items',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                    ],
                    end_point: 'report/sundry-slow-stock',
                    permission: 'download-sundry-items-data',
                    is_email: true,
                },
                {
                    name: 'rm-slow-stock-report',
                    title: 'Slow Stock Report - RM Items',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                    ],
                    end_point: 'report/raw-material-slow-stock',
                    permission: 'download-raw-materials-data',
                    is_email: true,
                },
                {
                    name: 'rm-order-items-sheet',
                    title: 'Purchase Orders by Items',
                    filters: [
                        { value: 'search', type: 'input', label: 'General Search', required: false, root_key: 'search' },
                        { key: '', value: 'date-from', options: [], type: 'date', label: 'From Date', root_key: 'date-from' },
                        { key: '', value: 'date-to', options: [], type: 'date', label: 'To Date', root_key: 'date-to' },
                        { key: 'supplier_id', value: 'supplier_id', options: [], type: 'dropdown', label: 'Supplier', select_type: 'single' },
                        { key: 'rm-item-status', value: 'item-status', options: [], type: 'dropdown', label: 'Order Item Status', root_key: 'item-status' },
                        { key: 'rm_order_payment_status', value: 'payment-status', options: [], type: 'dropdown', label: 'Payment Status', root_key: 'payment-status' },
                    ],
                    end_point: 'data/raw-material-order-items',
                    permission: 'download-raw-material-orders-data',
                },
                {
                    name: 'fg-batch-consumption-sheet',
                    title: 'FG Batch Consumption Sheet',
                    filters: [
                        { key: 'formulation_id' , value: 'formulation_id', options: [] , type: 'dropdown', label: 'Formulations', root_key: 'formulation-id', select_type: 'single', raw_filters: true},
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', root_key: 'from' , raw_filters: true},
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', root_key: 'to' , raw_filters: true },
                    ],
                    end_point: 'report/consumption-report/formulation-batch-usage',
                    permission: 'download-formulations-data'
                },
                {
                    name: 'courier-shipment-otif-sheet',
                    title: 'Courier Shipment OTIF Report',
                    filters: [
                        { key: '', value: 'from', options: [], type: 'date', label: 'From Date', required: true, root_key: 'from', raw_filters: true },
                        { key: '', value: 'to', options: [], type: 'date', label: 'To Date', required: true, root_key: 'to', raw_filters: true },
                    ],
                    end_point: 'data/courier-shipment-otif',
                    permission: 'download-courier-shipment-otif-data',
                },
                {
                    name: 'dev-to-live-coded-formulation',
                    title: 'DEV to LIVE Coded products',
                    filters: [
                        { key: '', value: 'month_year', options: [], type: 'month_year_date', label: 'Month and Year', required: true, raw_filters: true },
                    ],
                    end_point: 'report/formulation/formulation-dev-to-prod-change-report',
                    permission: 'view-formulations',
                },
                {
                    name: 'in-progress-work-order-stock',
                    title: 'In Progress Work Order Stock Document',
                    filters: [],
                    end_point: 'report/in-progress-work-order-stock-report',
                    permission: 'download-work-order-data',
                },
                {
                    name: 'approved-customers-report',
                    title: 'Approved Customer List',
                    filters: [
                        { key: '', value: 'from', options: [], type: 'date', label: 'Approved From Date', required: true, root_key: 'from' },
                        { key: '', value: 'to', options: [], type: 'date', label: 'Approved To Date', required: true, root_key: 'to' },
                        { key: 'account_type', value: 'account_type', options: [], type: 'dropdown', label: 'Account Type', select_type: 'single', root_key: 'account-type' },
                        { key: 'account_handler_id', value: 'account_handler_id', options: [], type: 'dropdown', label: 'Account Handler', root_key: 'account-handler' },
                    ],
                    end_point: 'report/approved-customers-report',
                    permission: 'download-customer-approval-report',
                },
            ],
        }
    },
    props: {
        name: {
            default: '',
            required: true,
            type: String,
        },
        filters: {
            required: false,
            default: null,
            type: Object
        },
        button_label : {
            required: false,
            default: 'Export Data',
            type: String
        },
        data_obj:{
            required: false,
            default: () => ({}),
            type: Object
        }
    },
    components: {
        DownloadExcelSheetPopUp
    },
    methods: {
        onClickDownload() {
      if (
        "check_data_available" in this.sheet_obj &&
        this.sheet_obj.check_data_available &&
        Object.keys(this.data_obj).length === 0
      ) {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "No Data Found",
          text: "There are no records available for the selected filters. Please adjust your filters and try again.",
          acceptText: "OK",
        });
      } else {
        this.$refs.downloadExcelSheetPopUp.openPopup(
          this.sheet_obj,
          this.filters
        );
      }
    },
    },
    computed: {
        sheet_obj: function () {
            return this.sheet_list.find((x) => x.name === this.name)
        }
    },
}
</script>
<style lang="">
    
</style>